import { turnBookingSpotlightOn } from '../../actions';

export default {
    turnBookingSpotlightOn,
};
